"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.APP_CLIENT_IDS = exports.REALM_NAMES = exports.PLATFORM_NAMES = exports.PRODUCT_NAMES = undefined;
exports.getAppElementByProduct = getAppElementByProduct;
exports.getThemedProduct = getThemedProduct;
exports.isKaraokeTsm = isKaraokeTsm;
exports.isKaraoke = isKaraoke;
exports.getBrandBackgroundImage = getBrandBackgroundImage;
exports.getBrandLogos = getBrandLogos;
exports.getProductClassName = getProductClassName;
exports.getProductClassNameWithoutClientId = getProductClassNameWithoutClientId;
exports.getProductName = getProductName;
exports.getProductNameWithoutClientId = getProductNameWithoutClientId;
exports.getPlatformProductName = getPlatformProductName;
exports.isIconButtonCenter = isIconButtonCenter;
exports.getMailLogo = getMailLogo;
exports.addExcludeHeaderParams = addExcludeHeaderParams;
exports.getTermsString = getTermsString;
exports.getPrivacyString = getPrivacyString;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Language = require("./Language");

var _components = require("./../components");

var _DefaultString = require("../helpers/DefaultString");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GENERIC_404_IMAGE = require("../../res/images/backgrounds/404_generic.png");
var logo = require("../../res/images/logo/stingray_logo_horizontal_white.svg");
var EMAIL_IMAGE = require("../../res/images/icon/email.svg");
var EMAIL_GREY_IMAGE = require("../../res/images/icon/email_gray.svg");

// Keep this to remember the client id.
// export const appClientId = {
//   BusinessClientId: 'qgGuvNro91kQItS5',
//   MusicClientId: 'zBUI4wDBNR1Ikz8L'
// };

var excludeHeaderParam = "?clean=1";

var PRODUCT_NAMES = exports.PRODUCT_NAMES = {
  Music: "MUSIC",
  Classica: "CLASSICA",
  Qello: "QELLO",
  Karaoke: "KARAOKE",
  KaraokeTsm: "KARAOKE_TSM"
};

var PLATFORM_NAMES = exports.PLATFORM_NAMES = {
  Web: "WEB",
  SmartSpeaker: "SMART_SPEAKER",
  Iphone: "IPHONE",
  Ipad: "IPAD",
  Android: "ANDROID",
  AndroidTablet: "ANDROID_TABLET",
  TV: "TV"
};

var REALM_NAMES = exports.REALM_NAMES = {
  Business: "STINGRAY_BUSINESS",
  Stingray: "STINGRAY"
};

var APP_CLIENT_IDS = exports.APP_CLIENT_IDS = {
  Karaoke: ["Ct3yaDK2QpmjXypF", "2:IftCZ9-aMWLoyVuo", // dev
  "2:ruQLap7Le2H-owZa", // test
  "2:D3dBTfGpILFgYU1g", // stage
  "2:0cWEHZP0JmFEHf-6"],
  KaraokeTsm: ["mNhXwrVYtsArZQ0K", "smc_wifi_aosp"]
};

function getAppElementByProduct(realm, product, children) {
  var element = void 0;
  switch (true) {
    case realm === REALM_NAMES.Business && product === PRODUCT_NAMES.Music:
      element = _react2.default.createElement(
        _components.CenterViewApp,
        null,
        children
      );
      break;
    case realm === REALM_NAMES.Stingray && (product === PRODUCT_NAMES.Music || product === PRODUCT_NAMES.Classica || product === PRODUCT_NAMES.Qello):
      element = _react2.default.createElement(
        _components.CenterViewApp,
        { hasHelp: true },
        children
      );
      break;
    default:
      element = _react2.default.createElement(
        _components.CenterViewApp,
        null,
        children
      );
      break;
  }
  return element;
}

function getThemedProduct(product, clientId) {
  return APP_CLIENT_IDS.KaraokeTsm.includes(clientId) ? PRODUCT_NAMES.KaraokeTsm : product;
}

function isKaraokeTsm(product, clientId) {
  return getThemedProduct(product, clientId) === PRODUCT_NAMES.KaraokeTsm;
}

function isKaraoke(product, clientId) {
  return getThemedProduct(product, clientId) === PRODUCT_NAMES.Karaoke;
}

function getBrandBackgroundImage(lang, realm, productName, clientId, platform) {
  var product = getThemedProduct(productName, clientId);
  var resource = void 0;
  switch (true) {
    case realm === REALM_NAMES.Business && product === PRODUCT_NAMES.Music:
      resource = _Language.resources.StingrayBusinessBackground;
      break;
    case realm === REALM_NAMES.Stingray && product === PRODUCT_NAMES.Music:
      resource = _Language.resources.StingrayMusicBackground;
      break;
    case realm === REALM_NAMES.Stingray && product === PRODUCT_NAMES.Classica && (platform === PLATFORM_NAMES.Iphone || platform === PLATFORM_NAMES.Android):
      resource = _Language.resources.StingrayClassicaBackgroundMobile;
      break;
    case realm === REALM_NAMES.Stingray && product === PRODUCT_NAMES.Classica && (platform === PLATFORM_NAMES.Ipad || platform === PLATFORM_NAMES.AndroidTablet):
      resource = _Language.resources.StingrayClassicaBackgroundTablet;
      break;
    case realm === REALM_NAMES.Stingray && product === PRODUCT_NAMES.Classica:
      resource = _Language.resources.StingrayClassicaBackground;
      break;
    case realm === REALM_NAMES.Stingray && product === PRODUCT_NAMES.Qello && (platform === PLATFORM_NAMES.Iphone || platform === PLATFORM_NAMES.Android):
      resource = _Language.resources.StingrayQelloBackgroundMobile;
      break;
    case realm === REALM_NAMES.Stingray && product === PRODUCT_NAMES.Qello && (platform === PLATFORM_NAMES.Ipad || platform === PLATFORM_NAMES.AndroidTablet):
      resource = _Language.resources.StingrayQelloBackgroundTablet;
      break;
    case realm === REALM_NAMES.Stingray && product === PRODUCT_NAMES.Qello:
      resource = _Language.resources.StingrayQelloBackground;
    case realm === REALM_NAMES.Stingray && product === PRODUCT_NAMES.Karaoke:
      resource = _Language.resources.StingrayKaraokeBackground;
      break;
    case realm === REALM_NAMES.Stingray && product === PRODUCT_NAMES.KaraokeTsm:
      resource = null;
      break;
    default:
      return GENERIC_404_IMAGE;
  }
  return resource && (0, _Language.translateResource)(lang, resource);
}

function getBrandLogos(lang, realm, product, clientId) {
  var productTheme = getThemedProduct(product, clientId);
  var resource = [];

  switch (true) {
    case realm === REALM_NAMES.Business && productTheme === PRODUCT_NAMES.Music:
      resource.push(_Language.resources.StingrayBusinessLogoHorizontal);
      break;
    case realm === REALM_NAMES.Stingray && productTheme === PRODUCT_NAMES.Music:
      resource.push(_Language.resources.StingrayMusicLogoHorizontal);
      break;
    case realm === REALM_NAMES.Stingray && productTheme === PRODUCT_NAMES.Classica:
      resource.push(_Language.resources.StingrayClassicaLogoHorizontal);
      break;
    case realm === REALM_NAMES.Stingray && productTheme === PRODUCT_NAMES.Qello:
      resource.push(_Language.resources.StingrayQelloLogoHorizontal);
      break;
    case realm === REALM_NAMES.Stingray && (productTheme === PRODUCT_NAMES.KaraokeTsm || APP_CLIENT_IDS.KaraokeTsm.includes(clientId)):
      resource.push(_Language.resources.TSMKaraokeLogoHorizontal);
      break;
    case realm === REALM_NAMES.Stingray && (productTheme === PRODUCT_NAMES.Karaoke || APP_CLIENT_IDS.Karaoke.includes(clientId)):
      resource.push(_Language.resources.KaraokeLogoHorizontal);
      break;
    default:
      return [logo];
  }

  return resource.map(function (item) {
    return (0, _Language.translateResource)(lang, item);
  });
}

function getProductClassName(realm, product, clientId) {
  var productTheme = getThemedProduct(product, clientId);
  var className = void 0;
  switch (true) {
    case realm === REALM_NAMES.Business && productTheme === PRODUCT_NAMES.Music:
      className = "business";
      break;
    case realm === REALM_NAMES.Stingray && productTheme === PRODUCT_NAMES.Music:
      className = "music roundStyleApp";
      break;
    case realm === REALM_NAMES.Stingray && productTheme === PRODUCT_NAMES.Classica:
      className = "b2cApp classica";
      break;
    case realm === REALM_NAMES.Stingray && productTheme === PRODUCT_NAMES.Qello:
      className = "b2cApp qello roundButton";
      break;

    // Add logic for validating client ID when SMC design is implemented.
    // This is because they share the same product name of PRODUCT_NAMES.Karaoke.
    // case realm === REALM_NAMES.Stingray && product === PRODUCT_NAMES.Karaoke && clientId === APP_CLIENT_IDS.Karaoke:
    case realm === REALM_NAMES.Stingray && productTheme === PRODUCT_NAMES.Karaoke:
      className = "karaoke";
      break;
    case realm === REALM_NAMES.Stingray && productTheme === PRODUCT_NAMES.KaraokeTsm:
      className = "karaokeTsm";
      break;
    default:
      break;
  }

  return className;
}

function getProductClassNameWithoutClientId(realm, product) {
  var className = void 0;
  switch (true) {
    case realm === REALM_NAMES.Business && product === PRODUCT_NAMES.Music:
      className = "business";
      break;
    case realm === REALM_NAMES.Stingray && product === PRODUCT_NAMES.Music:
      className = "music roundStyleApp";
      break;
    case realm === REALM_NAMES.Stingray && product === PRODUCT_NAMES.Classica:
      className = "classica";
      break;
    case realm === REALM_NAMES.Stingray && product === PRODUCT_NAMES.Qello:
      className = "qello";
      break;
    case realm === REALM_NAMES.Stingray && product === PRODUCT_NAMES.Karaoke:
      className = "karaoke";
      break;
    case realm === REALM_NAMES.Stingray && product === PRODUCT_NAMES.KaraokeTsm:
      className = "karaoke";
      break;
    default:
      break;
  }

  return className;
}

function getProductName(realm, product, clientId) {
  var productName = void 0;
  switch (true) {
    case realm === REALM_NAMES.Business && product === PRODUCT_NAMES.Music:
      productName = _DefaultString.translations.StingrayBusiness;
      break;
    case realm === REALM_NAMES.Stingray && product === PRODUCT_NAMES.Music:
      productName = _DefaultString.translations.StingrayMusic;
      break;
    case realm === REALM_NAMES.Stingray && product === PRODUCT_NAMES.Classica:
      productName = _DefaultString.translations.StingrayClassica;
      break;
    case realm === REALM_NAMES.Stingray && product === PRODUCT_NAMES.Qello:
      productName = _DefaultString.translations.StingrayQello;
      break;
    case realm === REALM_NAMES.Stingray && product === PRODUCT_NAMES.Karaoke && APP_CLIENT_IDS.KaraokeTsm.includes(clientId):
      productName = _DefaultString.translations.KaraokeTSM;
      break;
    case realm === REALM_NAMES.Stingray && (product === PRODUCT_NAMES.Karaoke || APP_CLIENT_IDS.Karaoke.includes(clientId)):
      productName = _DefaultString.translations.Karaoke;
      break;
    default:
      break;
  }

  return productName;
}

function getProductNameWithoutClientId(realm, product) {
  var productName = void 0;
  switch (true) {
    case realm === REALM_NAMES.Business && product === PRODUCT_NAMES.Music:
      productName = _DefaultString.translations.StingrayBusiness;
      break;
    case realm === REALM_NAMES.Stingray && product === PRODUCT_NAMES.Music:
      productName = _DefaultString.translations.StingrayMusic;
      break;
    case realm === REALM_NAMES.Stingray && product === PRODUCT_NAMES.Classica:
      productName = _DefaultString.translations.StingrayClassica;
      break;
    case realm === REALM_NAMES.Stingray && product === PRODUCT_NAMES.Qello:
      productName = _DefaultString.translations.StingrayQello;
      break;
    case realm === REALM_NAMES.Stingray && product === PRODUCT_NAMES.Karaoke:
      productName = _DefaultString.translations.Karaoke;
      break;
    case realm === REALM_NAMES.Stingray && product === PRODUCT_NAMES.KaraokeTsm:
      productName = _DefaultString.translations.KaraokeTSM;
      break;
    default:
      break;
  }

  return productName;
}

function getPlatformProductName(realm, product, platform, clientId) {
  var productName = void 0;
  if (platform === PLATFORM_NAMES.SmartSpeaker) {
    productName = _DefaultString.translations.SmartSpeakerStingrayMusic;
  } else {
    productName = getProductName(realm, product, clientId);
  }
  return productName;
}

function isIconButtonCenter(product) {
  return product === PRODUCT_NAMES.Classica || product === PRODUCT_NAMES.Qello;
}

function getMailLogo(product) {
  return product === PRODUCT_NAMES.Music ? EMAIL_IMAGE : EMAIL_GREY_IMAGE;
}

function addExcludeHeaderParams(url, excludeHeader) {
  if (excludeHeader) {
    url += excludeHeaderParam;
  }
  return url;
}

function getTermsString(formatMessage, productName, excludeHeader) {
  var termsConditionsTranslation = void 0;
  switch (productName) {
    case PRODUCT_NAMES.Classica:
      termsConditionsTranslation = _DefaultString.translations.TermsConditionsClassicaUrl;
      break;
    case PRODUCT_NAMES.Qello:
      termsConditionsTranslation = _DefaultString.translations.TermsConditionsQelloUrl;
      break;
    default:
      termsConditionsTranslation = _DefaultString.translations.TermsConditionsUrl;
  }
  var url = formatMessage(termsConditionsTranslation);
  return addExcludeHeaderParams(url, excludeHeader);
}

function getPrivacyString(formatMessage, productName, excludeHeader) {
  var privacyPolicyTranslation = _DefaultString.translations.PrivacyPolicyUrl;
  var url = formatMessage(privacyPolicyTranslation);
  return addExcludeHeaderParams(url, excludeHeader);
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/Product.js
// module id = 23
// module chunks = 0